export default class LocalStorageService {
  public setItem<T>(key: string, item: T): void {
    localStorage.setItem(key, JSON.stringify(item));
  }

  public getItem<T>(key: string): T {
    return JSON.parse(localStorage.getItem(key)) as T;
  }
}
